export default {
  products(state) {
    return state.products;
  },
  productLoading(state) {
    return state.loading;
  },
  searchMultiProducts(state) {
    return state.searchMultiselect;
  },
  productErrors(state) {
    return state.errors;
  }
};
